import { baseFetchToken } from './BaseSaga'
import CouponProviderActions from '../Redux/CouponProviderRedux'
import { getToken } from '../Services/GetToken'

export function * getCouponProvider (api, action) {
  yield baseFetchToken(
    api.getCouponProvider,
    action.data,
    getToken,
    CouponProviderActions.getCouponProviderSuccess,
    CouponProviderActions.getCouponProviderFailure
  )
}

export function * postCouponProvider (api, action) {
  yield baseFetchToken(
    api.postCouponProvider,
    action.data,
    getToken,
    CouponProviderActions.postCouponProviderSuccess,
    CouponProviderActions.postCouponProviderFailure
  )
}

export function * putCouponProvider (api, action) {
  yield baseFetchToken(
    api.putCouponProvider,
    action.data,
    getToken,
    CouponProviderActions.putCouponProviderSuccess,
    CouponProviderActions.putCouponProviderFailure
  )
}

export function * deleteCouponProvider (api, action) {
  yield baseFetchToken(
    api.deleteCouponProvider,
    action.data,
    getToken,
    CouponProviderActions.deleteCouponProviderSuccess,
    CouponProviderActions.deleteCouponProviderFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/CouponProviderSagas.js